export default __webpack_public_path__ + "static/media/drag-drop-full.6557cdf4.svg";